import {useMemo} from 'react';
import {StatusFilter, CategoryFilter} from '../utils/types';
import {filterEventsByStatus, filterEventsByCategory, getEventStatus} from '../utils/utils';
import {TEvent} from '../../../../../redux/event/event.type';

interface UseEventFiltersProps {
    events: TEvent[];
    statusFilter: StatusFilter;
    categoryFilter: CategoryFilter;
}

export function useEventFilters({events, statusFilter, categoryFilter}: UseEventFiltersProps) {

    const baseFilteredEvents = useMemo(() => {
        if(!events?.length) return [];
        
        const statusFiltered = filterEventsByStatus(events, statusFilter);
        return filterEventsByCategory(statusFiltered, categoryFilter);
    }, [events, statusFilter, categoryFilter]);

    // Get active events
    const activeEvents = useMemo(() => {
        if(!events?.length) return [];
        
        return events.filter(event => {
            const status = getEventStatus(event);
            return status === 'active';
        });
    }, [events]);

    return {
        baseFilteredEvents,
        activeEvents
    };
}
